module.exports = __webpack_public_path__ + "static/img/bmp.1f23463f.png";